// frontend/src/api/CNAuBIBICFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCMAMTOFERDAFiles = async () => {
  try {
    const response = await api.get("/cmam-toferda-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CMAM TOFERDA records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCMAMTOFERDAFileById = async (id) => {
  try {
    const response = await api.get(`/cmam-toferda-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CMAM TOFERDA file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCMAMTOFERDAFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cmam-toferda-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCMAMTOFERDAFiles = async (query) => {
  try {
    const response = await api.get(
      `/cmam-toferda-files/?search=${encodeURIComponent(query)}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error searching CMAM TOFERDA files with query "${query}":`,
      error,
    );
    throw error;
  }
};

// Crear un nuevo archivo
export const createCMAMTOFERDAFile = async (data) => {
  try {
    const response = await api.post("/cmam-toferda-files/", data);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Esto te da el JSON de DRF con los errores por campo
      console.error("Error creating CMAM TOFERDA file:", error.response.data);
    } else {
      console.error("Error creating CMAM TOFERDA file:", error.message);
    }
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCMAMTOFERDAFile = async (id, data) => {
  try {
    const response = await api.put(`/cmam-toferda-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CMAM TOFERDA file with ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCMAMTOFERDAFile = async (id) => {
  try {
    const response = await api.delete(`/cmam-toferda-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CMAM TOFERDA files:", error);
    throw error;
  }
};

export const exportCMAMTOFERDAFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(
      `/cmam-toferda-files/export/?ids=${idsParam}`,
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error exporting CMAM TOFERDA files by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCMAMTOFERDAFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cmam-toferda-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CMAM TOFERDA files:", error);
    throw error;
  }
};
